import { SseStatus, SseEvents, SseData } from '../states';

export const Sse = (data: SseData): EventSource => {
  const source: EventSource = new EventSource(`${data.url}`);

  // Event Handlers
  source.onopen = () => {
    data.setError(false);
    data.setStatus(SseStatus.open);
  };

  Object.values(SseEvents).forEach((item) => {
    source.addEventListener(item, (event) => {
      data.handleTimer(event);
      data.dispatchResults(event);
      if (event.type === SseEvents.OPERATION_FINISHED)
        data.setIsOperationFinished(true);
    });
  });

  source.onerror = () => {
    if (source.readyState === EventSource.CLOSED) {
      data.toastError();
      data.setStatus(SseStatus.error);
      data.setError(true);
      source.close();
    } else {
      data.setStatus(SseStatus.closed);
      source.close();
    }
  };

  return source;
};
